class Gallery extends HTMLElement {
  constructor() {
    super();

    this.active = this.querySelectorAll('.gallery-slide').length > 1;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if(this.active) {
      this.flkty.off('staticClick', this.clickNav.bind(this));
      this.flkty.destroy();
    }
  }

  init() {
    if(this.active) {
      this.flkty = new Flickity(this, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        autoPlay: 3500,
        cellSelector: '.gallery-slide'
      });
      this.flkty.on('staticClick', this.clickNav.bind(this));
    }

    let flkty = this.flkty;

    this.videos = this.querySelectorAll('video');
    this.images = this.querySelectorAll('img');

    this.videos.forEach(video => {
      video.addEventListener( "loadedmetadata", () => {
        // retrieve dimensions
        const height = this.videoHeight;
        const width = this.videoWidth;

        if(video.parentNode.classList.contains('ratio-box')) {
          video.parentNode.style.setProperty('--pad', ((height / width) * 100) + '%');
        }

        video.height = height;
        video.width = width;

        flkty.resize();
      }, {
        capture: false, 
        once: true, 
        passive: true
      });
    });

    this.images.forEach(image => {
      image.addEventListener( "complete", () => {
        flkty.resize();
      }, {
        capture: false, 
        once: true, 
        passive: true
      });
    });

    // this.lazyloadAnimation();
    this.media = this.querySelectorAll('.is-selected img, .is-selected video');
  }

  clickNav(e) {
    const xCoordInClickTarget = e.clientX - this.getBoundingClientRect().left;

    if (this.offsetWidth / 2 > xCoordInClickTarget) {
      this.flkty.previous();
    } else {
      this.flkty.next();
    }
  }
}
customElements.define('gallery-module', Gallery);